export const MAX_VERSION_NAME_LENGTH = 100;

export const MAPPING_VERSION_QUERY_KEYS = {
  nextVersionInfo: "getNextVersionInfo"
} as const;

export const EDIT_MAPPING_COPY = {
  title: "Edit supply chain mapping",
  description: "Tell us why this mapping is changing, then choose how the change should be stored.",
  reasonLabel: "Reason for the edit",
  reasonPlaceholder: "e.g. Replaced the pasteuriser with the new line after the June retrofit",
  modeLabel: "Do you want to update the current mapping or create a new version?",
  updateOptionLabel: "Update current mapping",
  updateOptionDescription: "The existing mapping is edited in place.",
  newVersionOptionLabel: "Create a new version",
  newVersionOptionDescription: "The current mapping stays untouched and the edit lands on a new version.",
  newVersionOptionDisabledReason: "Available once the current version has a completed calculation.",
  versionNameLabel: "Version name",
  versionNumberLabel: "Version number",
  cancel: "Cancel",
  submitUpdate: "Update mapping",
  submitNewVersionPrefix: "Create"
} as const;
